import React from 'react';
import BottomNavMobile from '../Components/BottomNavMobile';
import './doctor_profile_mobile.css';

export default function DoctorProfileMobile({
  formData,
  handleChange,
  handleSave,
  showPassword,
  setShowPassword,
  loading,
  notification
}) {
  return (
    <div className="mobile-profile-container" dir="rtl">
      {/* التنبيهات المنسدلة Toast / Alert */}
      {notification.show && (
        <div className={`status-alert alert-${notification.type}`} style={{ marginBottom: '15px' }}>
          {notification.type === 'loading' && <i className="fa-solid fa-circle-notch fa-spin"></i>}
          {notification.type === 'error' && <i className="fa-solid fa-triangle-exclamation"></i>}
          {notification.type === 'success' && <i className="fa-solid fa-circle-check"></i>}
          <span>{notification.message}</span>
        </div>
      )}

      {/* الهيدر العلوي */}
      <div className="mobile-profile-header">
        <img
          src="/images/Emblem_of_Syria_(2025–present).svg.png"
          alt="شعار الجمهورية"
          className="mobile-profile-logo"
        />
        <h1 className="mobile-profile-title">د. {formData.name || "الطبيب"}</h1>
        {formData.specialty && (
          <span className="mobile-profile-badge">{formData.specialty}</span>
        )}
      </div>

      {/* بطاقة المعلومات الشخصية */}
      <div className="mobile-profile-card">
        <div className="mobile-card-header">
          <i className="fa-solid fa-user-gear"></i>
          <h3>المعلومات الشخصية</h3>
        </div>

        <div className="mobile-profile-group">
          <label>الاسم الكامل</label>
          <div className="mobile-profile-input-wrapper">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="أدخل الاسم الثلاثي"
            />
            <i className="fa-solid fa-address-card input-icon"></i>
          </div>
        </div>

        <div className="mobile-profile-group">
          <label>اسم المستخدم</label>
          <div className="mobile-profile-input-wrapper">
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              dir="ltr"
              placeholder="Username"
            />
            <i className="fa-solid fa-user input-icon"></i>
          </div>
        </div>

        <div className="mobile-profile-group">
          <label>رقم الهاتف</label>
          <div className="mobile-profile-input-wrapper">
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              dir="ltr"
              placeholder="09xxxxxxx"
            />
            <i className="fa-solid fa-phone input-icon"></i>
          </div>
        </div>

        <div className="mobile-profile-group">
          <label>البريد الإلكتروني</label>
          <div className="mobile-profile-input-wrapper">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              dir="ltr"
              placeholder="email@example.com"
            />
            <i className="fa-solid fa-envelope input-icon"></i>
          </div>
        </div>
      </div>

      {/* بطاقة معلومات العمل */}
      <div className="mobile-profile-card">
        <div className="mobile-card-header">
          <i className="fa-solid fa-hospital-user"></i>
          <h3>معلومات العمل</h3>
        </div>

        <div className="mobile-profile-group">
          <label>التخصص الطبي</label>
          <div className="mobile-profile-input-wrapper">
            <input
              type="text"
              name="specialty"
              value={formData.specialty}
              onChange={handleChange}
              placeholder="التخصص الطبي"
            />
            <i className="fa-solid fa-user-doctor input-icon"></i>
          </div>
        </div>

        <div className="mobile-profile-group readonly">
          <label>المحافظة</label>
          <div className="mobile-profile-input-wrapper">
            <input type="text" value={formData.city} readOnly />
            <i className="fa-solid fa-location-dot input-icon"></i>
          </div>
        </div>

        <div className="mobile-profile-group readonly">
          <label>المشفى / المركز الصحي</label>
          <div className="mobile-profile-input-wrapper">
            <input type="text" value={formData.hospital} readOnly />
            <i className="fa-solid fa-hospital input-icon"></i>
          </div>
        </div>

        <div className="mobile-profile-group readonly">
          <label>عنوان المشفى</label>
          <div className="mobile-profile-input-wrapper">
            <input type="text" value={formData.hospitalAddress} readOnly />
            <i className="fa-solid fa-map input-icon"></i>
          </div>
        </div>
      </div>

      {/* بطاقة الأمان / كلمة المرور */}
      <div className="mobile-profile-card">
        <div className="mobile-card-header">
          <i className="fa-solid fa-shield-halved"></i>
          <h3>إعدادات الأمان</h3>
        </div>

        <div className="mobile-profile-group">
          <label>تغيير كلمة المرور</label>
          <div className="mobile-profile-input-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="أدخل كلمة مرور جديدة"
              autoComplete="new-password"
            />
            <i className="fa-solid fa-lock input-icon"></i>
            <i
              className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'} toggle-password-icon`}
              onClick={() => setShowPassword(!showPassword)}
            ></i>
          </div>
        </div>
      </div>

      {/* زر الحفظ */}
      <button
        className="mobile-profile-save-btn"
        onClick={handleSave}
        disabled={loading}
      >
        {loading ? (
          <>
            <i className="fa-solid fa-circle-notch fa-spin"></i>
            <span>جاري الحفظ...</span>
          </>
        ) : (
          <>
            <i className="fa-solid fa-floppy-disk"></i>
            <span>حفظ التعديلات</span>
          </>
        )}
      </button>

      {/* شريط التنقل السفلي */}
      <BottomNavMobile />
    </div>
  );
}